import React from "react";
import { TextField } from "@mui/material";
const MedicalHistory = ({ value, onChange }) => (
  <TextField fullWidth multiline rows={12} label="Long-term Clinical History" value={value} onChange={(e) => onChange(e.target.value)} />
);
export default MedicalHistory;